<template>
  <div v-ps class="project-info">
    <header class="top-wrap">
      <div class="main-title">项目信息</div>
    </header>
    <main>
      <div class="group">
        <header>项目信息</header>
        <el-form ref="form" :model="projectInfo" :rules="rules" label-width="120px">
          <el-form-item prop="name" label="项目名称">
            <el-input v-model.trim="projectInfo.name"></el-input>
          </el-form-item>
          <el-form-item prop="id" label="项目ID">
            <el-input disabled v-model.trim="projectInfo.id"></el-input>
          </el-form-item>
          <el-form-item prop="icon" label="设计图标" class="design-icon">
            <span class="icon-info">
              <svg-icon
                style="color: #fff"
                :icon-class="
                  projectInfo.icon ? 'project_' + projectInfo.icon : 'project_' + projectIcons[0]
                "
              ></svg-icon>
            </span>
            <design-icon-popper
              style="margin: 8px"
              :icons="projectIcons"
              :cur-data="projectInfo"
              from="project"
              @changeData="changeProjectInfo"
            ></design-icon-popper>
          </el-form-item>
          <el-form-item prop="period" label="项目周期">
            <el-date-picker
              v-model="projectInfo.period"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="introduce" label="项目简介">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="projectInfo.description"
            ></el-input>
          </el-form-item>
          <el-form-item prop="relationName" label="关联项目ID">
            <el-input v-model="projectInfo.relationProjectId"></el-input>
          </el-form-item>
          <el-form-item prop="relationId" label="关联项目名称">
            <el-input disabled v-model="projectInfo.relationProjectName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="group">
        <header>项目状态</header>
        <el-form ref="form" :model="projectInfo" :rules="rules" label-width="120px">
          <el-form-item prop="status" label="项目状态">
            <el-select v-model="projectInfo.statusValue">
              <el-option
                v-for="(status, index) in projectStatus"
                :key="index"
                :label="status.label"
                :value="status.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="desc" label="状态描述">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入内容"
              v-model="projectInfo.statusDesc"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="group">
        <header>其他信息</header>
        <el-form ref="form" :model="projectInfo" label-width="120px">
          <el-form-item prop="robotToken" label="机器人ToKen">
            <el-input v-model="projectInfo.robotToken"></el-input>
          </el-form-item>
          <el-form-item prop="secret" label="机器人密钥">
            <el-input v-model="projectInfo.secret"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:center;margin-left:0;">
          <el-button type="primary" size="small" style="margin-top: 62px" @click="save">
            保存
          </el-button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import * as projectApi from "@/api/project/project"
import { projectStatus } from "~/data/project"
import { projectIcons } from "./static"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"

export default {
  name: "project-info",
  components: {
    DesignIconPopper
  },
  data() {
    return {
      projectStatus,
      projectIcons,
      rules: {
        name: [{ required: true, message: "项目名称不能为空", trigger: "blur" }],
        period: [{ required: true, message: "项目周期不能为空", trigger: "blur" }]
      },
      projectInfo: {},
    }
  },
  methods: {
    save() {
      this.projectInfo.startPeriod = this.projectInfo.period[0]
      this.projectInfo.endPeriod = this.projectInfo.period[1]
      projectApi
        .updateProject(this.projectInfo, this.$route.params.projectId)
        .then(res => {
          this.$message.success("操作成功！")
        })
        .finally(() => (this.loading = false))
    },
    changeProjectInfo(key, val) {
      this.$set(this.projectInfo, key, val)
    }
  },
  created() {
    projectApi.getProject(this.$route.params.projectId).then(data => {
      this.projectInfo = data
      if (data.startPeriod && data.endPeriod) {
        this.$set(this.projectInfo, "period", [data.startPeriod, data.endPeriod])
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.project-info {
  height: 100%;
  position: relative;

  main {
    padding: 10px 15px 10px 36px;
    box-sizing: border-box;
  }

  .group {
    &:not(:first-child) {
      padding-top: 20px;
    }

    header {
      position: relative;
      margin-bottom: 16px;
      color: $color-font-first;
      font-size: $font-size-title-topic;
      line-height: 28px;

      &::before {
        content: "";
        position: absolute;
        left: -16px;
        width: 6px;
        height: 28px;
        border-radius: 4px;
        background-color: $color-main;
      }
    }

    ::v-deep {
      .el-form-item {
        margin-bottom: 18px;

        .el-form-item__label {
          text-align: left;
        }
      }

      .el-form-item__content {
        .el-input {
          width: 350px;
        }

        .el-textarea {
          width: 350px;
        }
      }

      .el-form-item .el-form-item__label,
      .el-form-item .el-form-item__content,
      .el-date-editor {
        height: 32px;
        line-height: 32px;
      }

      .el-form-item .el-form-item__content {
        height: auto;
      }

      .el-date-editor .el-input__icon,
      .el-date-editor .el-range-separator {
        line-height: 24px;
      }
    }
    .design-icon {
      .icon-info {
        background: #1989fa;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 48px;
        height: 48px;
        font-size: 30px;
        border-radius: 6px;
      }
      ::v-deep {
        .el-form-item__content {
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
}
</style>
